
import { Component, Vue , Emit, Prop, Watch} from "vue-property-decorator";
import {
    UpdateOrderRecordStateInput,
    OrderRecordBySchoolDto,
    AdvertisingSpaceInput,
} from "@/api/service-proxies";
import { __param } from "tslib";
import { orderRecordService } from "@/api/payments/order-record";
import * as imageConversion from 'image-conversion'
import appconst from '@/lib/appconst'
@Component
export default class AdvertisingDialog extends Vue {
   @Prop({ default: null })
  private url : string

  @Prop({ default: '上传人脸照片' })
  private content : string

  @Watch('url')
  private onUrlChange(val) {
    this.previewImageUrl = val
  }
    private dialogVisible: boolean = false;
    phoneNumber = "";
    isSkipHolidays: boolean = false;
    isExporting: boolean = false;
    orderRecordBySchoolDto = new OrderRecordBySchoolDto();
    input = new UpdateOrderRecordStateInput();
    id = 0;
    type = 0;
    schoolId = 0;
    coverUrl: string = "";
    jumpAddress: string = "";
    spaceInput = new AdvertisingSpaceInput();
    aaa:[] 
    loading=false
    schoolName=''
    // type =0 ,为新增，type=1 为修改
    public open(id,schoolId, type, coverUrl,jumpAddress,schoolName) {
        this.id = id;
        this.type = type;
        this.schoolId = schoolId;
        this.coverUrl = coverUrl;
        this.jumpAddress = jumpAddress;
        this.dialogVisible = true;
        this.schoolName=schoolName
    }
    close() {
        this.dialogVisible = false;
        
    }
    
  private faceUploadAction =  `${appconst.remoteServiceBaseUrl}/sysadmin/api/UploadFile/ImgSecCheck`
  private previewImageUrl = null
  private faceUploading = false

 

  private mounted() {
    this.previewImageUrl = this.url
  }
  
  private onFaceUpladSuccess(response, file, fileList) {
    this.faceUploading = false
    this.previewImageUrl = response.result.url
    //this.onUpSuccess(response.result.url)
  }

  private onFaceUploadError(error) {
    this.faceUploading = false
    this.previewImageUrl = this.url
    try {
      let data = JSON.parse(error.message)
      if (data.error.message) {
        if (data.error.details) {
          this.$message({
            type: "error",
            message: this.$createElement("p", [
              this.$createElement("p", { style: { fontSize: '14px', color: '#999', marginBottom: '6px' } }, data.error.message),
              this.$createElement("p", data.error.details)
            ])
          })
        } else {
          this.$message.error(data.error.message)
        }
      } else {
        this.$message.error('人脸图片上传失败')
      }
    } catch {
      this.$message.error('人脸图片上传失败')
    }
  }

  private onFaceBeforeUpload(file) {
    console.log("ssdsds")
    return new Promise((resolve, reject) => {
      var sizeLength = (file.size/1024/1024)<30//不能大于30M
      if (!(file.type === "image/jpeg" || file.type === "image/png")) {
        this.$message.error("上传图片只能是jpg或png格式")
        reject();
      }else if(!sizeLength){
        this.$notify.warning("上传图片不能超过30M")
        return;
      }else {
        this.previewImageUrl = URL.createObjectURL(file)
        imageConversion
        .compressAccurately(file, { size: 800 })
        .then(res => {
          this.faceUploading = true
          resolve(res);
        });
      }
    })
  }

  // @Emit('successs')
  // private onUpSuccess(url: string){}

  @Emit("success")
  private onSuccess() {}


  submit() {
      this.isExporting = true;
      this.spaceInput.jumpAddress = this.jumpAddress
      this.spaceInput.coverUrl = this.coverUrl
      this.spaceInput.orderNumber = 0
      if (this.type == 0) {
          this.spaceInput.id = 0
          this.spaceInput.tenantId = this.schoolId;
          console.log( this.spaceInput)
          orderRecordService
              .createAdvertisingSpace(this.spaceInput)
              .then((result)=>{
                  this.$message.success("新增成功");
                  this.onSuccess()
              })
              .catch((error)=>{
                  this.$message.error("新增失败");
              })
              .finally(() => {
                  this.dialogVisible = false
                  this.isExporting = false;
              });
      } else {
          this.spaceInput.id = Number(this.id)
          this.spaceInput.tenantId = Number(this.schoolId)
          orderRecordService
              .updateAdvertisingSpace(this.spaceInput)
              .then((result)=>{
                  this.$message.success("编辑成功");
                  this.onSuccess()
              })
              .catch((error)=>{
                  this.$message.error("编辑失败");
              })
              .finally(() => {
                  this.dialogVisible = false
                  this.isExporting = false;
              });
      }
    }
}
